import React, { useState, useEffect, memo, useRef, cloneElement } from "react"
import { makeStyles } from "@material-ui/core/styles"
import useHandleRequestSnackbar from "@/hooks/useHandleRequestSnackbar"
import RequestSnackbar from "@/components/common/RequestSnackbar"
import Box from "@material-ui/core/Box"
import Loading from "@/components/common/Loading"
import clsx from "clsx"
import { getParticipantByParticipantUUID } from "@/apisParticipantPublic"
import { useParams, useSearchParams } from "react-router-dom"

const useStyles = makeStyles(() => ({
    contentWrapper: {
        flex: "1 1 auto",
        display: "flex",
        flexDirection: "column",
    },
}))

const PublicRouteCheckParticipantPermission = memo(({ children }) => {
    // check access token
    const classes = useStyles()
    const params = useParams()
    const { participantUUID } = params
    const [searchParams] = useSearchParams()

    const [participantCheckLoading, setParticipantCheckLoading] = useState({
        loading: true,
        error: false,
        message: "",
    })
    const [participantDetail, setParticipantDetail] = useState()
    const updateParticipant = (updateDetail, key, value) => {
        if (!key) {
            setParticipantDetail((prev) => ({ ...prev, ...updateDetail }))
        } else {
            setParticipantDetail((prev) => ({ ...prev, [key]: value }))
        }
    }

    useEffect(() => {
        const validateParticipant = async () => {
            const participantPublicAccessToken = searchParams.get("token")
            localStorage.setItem("participantPublicAccessToken", JSON.stringify(participantPublicAccessToken))
            try {
                const participantDetailData = await getParticipantByParticipantUUID(participantUUID)
                const participantInfo = participantDetailData.data.participant
                setParticipantDetail(participantInfo)
                setParticipantCheckLoading({
                    loading: false,
                    error: false,
                    message: "success",
                })
            } catch (error) {
                setParticipantCheckLoading({
                    loading: false,
                    error: true,
                    message: error?.data?.message || "request error",
                    errorCode: error?.code,
                })
            }
        }
        validateParticipant(participantUUID)
    }, [searchParams, participantUUID])

    const requestSnackbarValue = useHandleRequestSnackbar(true)

    const headerRef = useRef(null)
    const headerHeight = headerRef.current ? headerRef.current.getHeaderHeight() : 0

    return (
        <>
            {participantCheckLoading.loading ? (
                <Box className={clsx(classes.contentWrapper, classes.loading)}>
                    <Loading content="Checking Participants Permission ..." transformX={90} />
                </Box>
            ) : (
                cloneElement(children, {
                    participantCheckLoading,
                    participantDetail,
                    headerHeight,
                    updateParticipant,
                })
            )}
            {!!participantCheckLoading.error && (
                <RequestSnackbar
                    status={!participantCheckLoading.error}
                    message={participantCheckLoading.message}
                    snackbarOpen={requestSnackbarValue.snackbarOpen}
                    handleSnackbarOpenStatus={requestSnackbarValue.handleSnackbarOpenStatus}
                />
            )}
        </>
    )
})

export default PublicRouteCheckParticipantPermission
